<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <DashboardHeader />
    <v-row v-if="mobile()">
      <v-col
        cols="11"
        class="d-flex justify-end mt-n3 mx-auto"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row v-else class="mt-n14">
      <v-col
        cols="4"
        class="mx-auto mt-n4 d-flex justify-end"
      >
        <SearchBarGlobal
          :space-id="spaceId"
          :size-activities="sizeActivities"
          :size-hubs="sizeHubs"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="activities.length == 0 && !loadingData"
      align="center"
      class="mt-16"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-text="$t('emptyActivitiesPageTextParticipant')"
          page-image="image2"
        />
      </v-col>
    </v-row>
    <v-row v-if="activities.length > 0 && !loadingData">
      <v-col
        :cols="mobile() ? '12' : '11'"
        :class="mobile() ? '' : 'mx-auto'"
      >
        <v-row align="center">
          <v-col
            v-for="item in activities"
            :key="item.id"
            cols="12"
            sm="6"
            lg="4"
            xl="3"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="345"
                data-testid="activity-card"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
                :to="'/activity/'+item.id"
              >
                <v-responsive class="rounded-b-0">
                  <v-img
                    class="rounded-t-xl"
                    :src="(item.attributes.image) ? item.attributes.image : require('../../assets/cover-activity.jpg')"
                    height="195px"
                  />
                </v-responsive>
                <v-card-text class="pa-0" style="height: 80px;">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="py-0"
                      style="height:80px"
                    >
                      <v-card-title class="text-left darktext--text no-break px-4 py-2">
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pa-0" style="height: 70px;">
                  <v-row
                  class="mx-auto fill-height pa-2"
                  >
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      class="d-flex align-end px-4 py-0"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-chip
                            small
                            data-testid="sharing-setting-chip"
                            color="darktext"
                            text-color="white"
                            filter-icon="mdi-equalizer-outline"
                            v-on="on"
                          >
                            <v-icon
                              size="14"
                              class="pr-1"
                            >
                              mdi-share-variant
                            </v-icon>
                            <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestricted') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexible') }}</span>
                            <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpen') }}</span>
                          </v-chip>
                        </template>
                        <span v-if="item.attributes.sharing_setting == 'Restricted'">{{ $t('sharingSettingRestrictedTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Flexible'">{{ $t('sharingSettingFlexibleTooltip') }}</span>
                        <span v-if="item.attributes.sharing_setting == 'Open'">{{ $t('sharingSettingOpenTooltip') }}</span>
                      </v-tooltip>
                    </v-col>
                    <v-col>
                      <v-progress-linear :value="item.meta.statistics.data.percentage" :color="item.meta.statistics.data.percentage == 0 ? 'greytextlight' : 'success'" height="16" class="rounded-xxl" data-testid="progress-linear"><span class="text-caption">{{ item.meta.statistics.data.percentage }}%</span></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <Pagination
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="activitiesInfo.total"
      :page-number="activitiesInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
    />
  </nav>
</template>

<script>
import i18n from '../../plugins/i18n'
import { getAllActivities } from '../../api/activityApi'
import Pagination from '../../components/Pagination'
import EmptyPage from '../../components/EmptyPage'
import VClamp from 'vue-clamp'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import DashboardHeader from '../../components/DashboardHeader'
import SearchBarGlobal from '../../components/SearchBarGlobal'

export default {
    components: {
        Pagination,
        EmptyPage,
        VClamp,
        AlertMessages,
        DashboardHeader,
        SearchBarGlobal
    },
    mixins: [repeatedMethodsMixin],

    data(){
        return{
            activities: [],
            activitiesInfo: {
                currentPage: 1,
                total: 1,
            },
            permissions: [],
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertType:'',
            alertValue:false,
            pageNumber: 1,
            size: 12,
            link: {title: '', route: '/activity/create'},
            loadingData: false,
            sharingSettingRestricted: i18n.t('sharingSettingRestricted'),
            sharingSettingFlexible: i18n.t('sharingSettingFlexible'),
            sharingSettingOpen: i18n.t('sharingSettingOpen'),
            sharingSettingRestrictedTooltip: i18n.t('sharingSettingRestrictedTooltip'),
            sharingSettingFlexibleTooltip: i18n.t('sharingSettingFlexibleTooltip'),
            sharingSettingOpenTooltip: i18n.t('sharingSettingOpenTooltip')
        }
    },

    async created(){
        this.loadingData = true
        await this.fetchActivities()
        this.loadingData = false
    },
    computed: {
      sizeHubs() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 3
          default: return 2
        }
      },
      sizeActivities() {
        switch (this.$vuetify.breakpoint.name) {
          case 'xl': return 4
          default: return 6
        }
      },
    },
    methods:{
        handlePageChange(value){
            this.activitiesInfo.currentPage = value
            this.pageNumber = value
            this.fetchActivities()
        },
        showhubPage(){
            this.$router.push({path: '/all-hubs-participant'})
        },
        showActivityPage(){
            this.$router.push({path: '/all-activities-participant'})
        },
        seeAll(){
            this.$router.push({path: '/dashboard-participant'})
        },
        async fetchActivities(){
            try {
                const response = await getAllActivities(this.spaceId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.activities = response.data.data
                        window.scrollTo(0,0)
                        if(response.data.meta.page){
                            this.activitiesInfo = response.data.meta.page
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        this.$router.push({name: 'PageNotFound'})
                    }
                    else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        }
    }
}

</script>
